import { BillingAccountService } from 'app/API';
import { cancelOnSignal } from 'app/API/core/CancelablePromise';
import type { QueryFunctionContext } from '@tanstack/react-query';
import type { billingKeys } from 'app/queries/billing/billingKeys';
import type { TCall } from 'app/queries/types/TCall';

type TParams = QueryFunctionContext<ReturnType<typeof billingKeys.account>>;

export const createFetchBillingAccountQueryFn =
  (call: TCall) =>
  ({ queryKey: [{ baId }], signal }: TParams) =>
    call(() => cancelOnSignal(BillingAccountService.adminFindOne({ baId }), signal));
